@if (display | async; as display) {
  <div
    data-cy="modal-container-bg"
    class="modal-container"
    (click)="modalService.disableClose ? null : closeModal()"
    (keydown.space)="modalService.disableClose ? null : closeModal()"
    (keydown.enter)="modalService.disableClose ? null : closeModal()"
    tabindex="0"
    [ngClass]="{
      'modal-container--toggled': display === 'open'
    }"
    [ngStyle]="{ 'padding-top.px': nativeSafeZoneService.paddings.top }"
  >
    <div
      class="modal-window"
      (click)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      tabindex="0"
      [ngClass]="{
        'modal-window--consultant': modalService.consultant || modalService.consultant === 404,
        'modal-window--dynamic': modalService.sucessfullySigned || modalService.additionalSignErrored || modalService.withdrawConfirmTemp || modalService.etfLanguageConfirm || modalService.investmentQuestionaireExpired || modalService.portfolioToDelete || modalService.investmentConfirm || modalService.initSignIn || modalService.rebalancingSwitchoffConfirm || modalService.feeChangeConfirm || modalService.draftAcceptRefuseConfirm || modalService.executionSwitchAddition || modalService.portfoliosMigrateAddition || modalService.clientAddition || modalService.efektikaDraftAcceptConfirm || modalService.efektikaDraftAcceptRegularExceedConfirm || modalService.cancelRegularWithdrawal || (modalService.newRegularWithdrawal && !modalService.newRegularWithdrawal.dip) || modalService.draftWithdrawalComment,
        'modal-window--small': modalService.rebalancingControl || modalService.withdraw || modalService.dipControl || modalService.efektikaDraftAcceptDipConfirm || modalService.newPortfolioVatConfirm || modalService.draftPortfolioVatConfirm,
        'modal-window--fees': modalService.feeConfigs || modalService.profileFeesConfirm,
        'modal-window--thin': modalService.transactionsExportForm,
      }"
    >
      @if (!modalService.disableClose) {
        <button class="button-close" (click)="closeModal()" data-cy="modal-close-button">
          <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'height.px':25, 'width.px':25 }"></svg-icon>
        </button>
      }
      <!-- whole modal preloader -->
      @if (modalService.preloader) {
        <div class="modal-preloader-container">
          <libero-preload-spinner></libero-preload-spinner>
        </div>
      }
      <!-- money deposit with QR -->
      @if (modalService.moneyDeposit) {
        <div #moneyDepositEl class="payment-desktop-padding" data-cy="money-deposit-modal-window">
          <div class="payment-desktop-layout">
            <div class="payment-desktop-layout-container">
              <h1 data-cy="deposit-modal-header">{{ 'modal.moneyDeposit' | translate }}</h1>
              @if (modalService.moneyDeposit.strategy) {
                <div class="strategy">
                  @if (modalService.moneyDeposit.new) {
                    <div>
                      {{ 'modal.newStrategyPartOne' | translate }}
                      "{{ modalService.moneyDeposit.name }}"
                      {{ 'modal.newStrategyPartTwo' | translate }}
                    </div>
                  } @else {
                    {{ 'modal.existingStrategyPartOne' | translate }}
                    "{{ modalService.moneyDeposit.name }}"
                    {{ 'modal.existingStrategyPartTwo' | translate }}
                  }
                </div>
              }
              @if (modalService.moneyDeposit.portfolio) {
                <div class="portfolio">
                  @if (modalService.moneyDeposit.new) {
                    <div>
                      {{ 'modal.existingPortfolioPartOne' | translate }}
                      "{{ modalService.moneyDeposit.name }}"
                      {{ 'modal.existingPortfolioPartTwo' | translate }}
                    </div>
                  } @else {
                    {{ 'modal.existingPortfolioPartOne' | translate }}
                    "{{ modalService.moneyDeposit.name }}"
                    {{ 'modal.existingPortfolioPartTwo' | translate }}
                  }
                </div>
              }
              <hr class="divider">
              <div class="deposit-money" data-cy="deposit-bank-details">
                {{ 'modal.nowDepositMoney' | translate }}
              </div>
              <div class="payment-info-container">
                <div class="row payment-info" data-cy="deposit-bank-account-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.accountNumber' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ modalService.moneyDeposit.accountNumber }} / {{ modalService.moneyDeposit.bankCode }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-variable-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.variableSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ modalService.moneyDeposit.variableSymbol }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-specific-symbol-header">
                  <div class="col-12 payment-info--label">
                    {{ 'modal.specificSymbols' | translate }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-regular-specific-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.regularSpecificSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ configService.getConfig(EnvironmentKeys.regularSpecificCode) }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-one-time-specific-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.oneTimeSpecificSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ configService.getConfig(EnvironmentKeys.oneTimeSpecificCode) }}
                  </div>
                </div>
              </div>
              <div class="footer-description desktop-content" data-cy="deposit-footer-description">
                {{ 'modal.moneyDepositFooterDescriptionPart1' | translate }}
                <b>
                  {{ 'modal.moneyDepositFooterDescriptionPart2' | translate }}
                </b>
                {{ 'modal.moneyDepositFooterDescriptionPart3' | translate }}
                <hr class="divider divider--no-spacing mt-2">
              </div>
              @if (modalService.moneyDeposit.totalEntryFee) {
                <div data-cy="total-fee-container" class="row payment-info">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.totalEntryFee' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    <div class="tooltipped-value">
                      {{ modalService.moneyDeposit.totalEntryFee | price:modalService.moneyDeposit.currency }}
                      <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                        {{ 'modal.initialFeeTooltipPart1' | translate }}
                        <b>
                          {{ 'modal.initialFeeTooltipPart2' | translate }}
                          {{ configService.getConfig(EnvironmentKeys.regularSpecificCode) }}
                        </b>
                        {{ 'modal.initialFeeTooltipPart3' | translate }}.
                      </libero-tooltip-button>
                    </div>
                  </div>
                </div>
              }
              @if (modalService.moneyDeposit.vatAlreadyPaid && modalService.moneyDeposit.entryFeeAlreadyPaidWithVat) {
                <div data-cy="portfolio-paid-VAT--container" class="row payment-info payment-info--downsized">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.entryFeeAlreadyPaid' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    <b data-cy="already-paid-fee-with-VAT">{{ modalService.moneyDeposit.entryFeeAlreadyPaidWithVat | price:modalService.moneyDeposit.currency }}</b>
                  </div>
                  <div class="col-12">
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt1' | translate }}
                    <b data-cy="already-paid-fee">{{ modalService.moneyDeposit.feeAlreadyPaid | price:modalService.moneyDeposit.currency }}</b>
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt2' | translate }}
                    <b data-cy="already-paid-VAT">{{ modalService.moneyDeposit.vatAlreadyPaid | price:modalService.moneyDeposit.currency }}</b>
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt3' | translate }}
                  </div>
                </div>
              } @else {
                @if (
                  modalService.moneyDeposit.regularDeposit &&
                  ((modalService.moneyDeposit.vatAlreadyPaid === 0)
                  && ( modalService.moneyDeposit.entryFeeAlreadyPaidWithVat === 0)
                  || (modalService.moneyDeposit.entryFeeAlreadyPaid || modalService.moneyDeposit.entryFeeAlreadyPaid === 0))) {
                  <div
                    data-cy="already-paid-container"
                    class="row payment-info"
                    >
                    <div class="col-6 payment-info--label">
                      {{ 'modal.entryFeeAlreadyPaid' | translate }}
                    </div>
                    <div class="col-6 payment-info--value">
                      {{ modalService.moneyDeposit.entryFeeAlreadyPaid ?? 0 | price:modalService.moneyDeposit.currency }}
                    </div>
                  </div>
                }
              }
              @if (modalService.moneyDeposit.unpaidAmountWithVat) {
                <div data-cy="unpaid-VAT-container" class="row payment-info">
                  <div class="col-6 payment-info--label">
                    {{ ('modal.portfolioVAT.' + (modalService.moneyDeposit.portfolio ? 'totalUnpaidEntryFeeWithVAT' : 'totalEntryFeeWithoutVAT') ) | translate }}
                  </div>
                  <div class="col-6 payment-info--value" data-cy="unpaid-with-VAT">
                    {{ modalService.moneyDeposit.unpaidAmountWithVat | price:modalService.moneyDeposit.currency }}
                  </div>
                </div>
              }
            </div>
            <div class="qr-container" data-cy="deposit-qr-container">
              <div class="qr-code">
                <div class="qr-payment-label" data-cy="deposit-regular-qr-desc">
                  {{ 'modal.regularQr' | translate }}
                </div>
                <libero-qr-payment
                  [accountNumber]="modalService.moneyDeposit.accountNumber"
                  [variableSymbol]="modalService.moneyDeposit.variableSymbol"
                  [specificSymbol]="configService.getConfig(EnvironmentKeys.regularSpecificCode)"
                  [amount]="modalService.moneyDeposit.regularDeposit"
                  [bankCode]="modalService.moneyDeposit.bankCode"
                  [currency]="modalService.moneyDeposit.currency"
                  data-cy="deposit-regular-qr"
                ></libero-qr-payment>
              </div>
              <div class="qr-code">
                <div class="qr-payment-label" data-cy="deposit-one-time-qr-desc">
                  {{ 'modal.oneTimeQr' | translate }}
                </div>
                <libero-qr-payment
                  [accountNumber]="modalService.moneyDeposit.accountNumber"
                  [variableSymbol]="modalService.moneyDeposit.variableSymbol"
                  [specificSymbol]="configService.getConfig(EnvironmentKeys.oneTimeSpecificCode)"
                  [bankCode]="modalService.moneyDeposit.bankCode"
                  [currency]="modalService.moneyDeposit.currency"
                  data-cy="deposit-one-time-qr"
                ></libero-qr-payment>
              </div>
              @if (modalService.moneyDeposit.dip) {
                <div class="dip-pdf">
                  @if (modalService.dipPreloader) {
                    <libero-preload-spinner></libero-preload-spinner>
                  } @else {
                    {{ 'modal.generateDipQr' | translate }}
                    <div
                      class="generate-dip-pdf"
                      (click)="modalService.generateDipPdf()"
                      (keydown.space)="modalService.generateDipPdf()"
                      (keydown.enter)="modalService.generateDipPdf()"
                      tabindex="0"
                    >
                      {{ 'modal.generate' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="footer-description phone-content">
            {{ 'modal.moneyDepositFooterDescriptionPart1' | translate }}
            <b>
              {{ 'modal.moneyDepositFooterDescriptionPart2' | translate }}
            </b>
            {{ 'modal.moneyDepositFooterDescriptionPart3' | translate }}
          </div>
        </div>
      }
      <!-- consultant  -->
      @if (modalService.consultant && modalService.consultant.value.status === consultStatus.NOT_FOUND && !modalService.preloader) {
        <div class="no-consult no-consult--heading" data-cy="modal-consultant-container-no-consult">
          {{ 'modal.noAssignedConsultHeader' | translate }}
        </div>
        <div class="no-consult" [innerHTML]="'modal.noAssignedConsult' | translate "></div>
      } @else {
        @if (modalService.consultant && modalService.consultant.value.value && !modalService.preloader && modalService.consultant.value.status !== consultStatus.NOT_FOUND) {
          <div
            class="consult-padding"
            data-cy="modal-consultant-container"
          >
            <h1>{{ 'modal.yourConsultant' | translate }}</h1>
            <div class="phone-image-container">
              @if (modalService.consultant.image && modalService.consultant.image.status !== consultStatus.BLANK) {
                <libero-consult-image [imageSrc]="consultImage"></libero-consult-image>
              }
            </div>
            <div class="phone-name-container">
              <div class="phone-name-container--name">
                {{ modalService.consultant.value.value.name }}
              </div>
              <div class="phone-name-container--surname">
                {{ modalService.consultant.value.value.surname }}
              </div>
            </div>
            <div class="desktop-name-container">
              <div class="desktop-name-container--name">
                {{ modalService.consultant.value.value.name }}
              </div>
              <div class="desktop-name-container--surname">
                {{ modalService.consultant.value.value.surname }}
              </div>
            </div>
            <div class="consult-desktop-layout">
              <div class="desktop-image-container">
                @if (modalService.consultant.image && modalService.consultant.image.status !== consultStatus.BLANK) {
                  <div class="image-border">
                    @if (modalService.consultant.image && modalService.consultant.image.status !== consultStatus.NOT_FOUND) {
                      <img
                        width="160px"
                        height="160px"
                        [src]="modalService.consultant.image.value"
                        data-cy="modal-consult-photo"
                        alt="consultant photo"
                      >
                    } @else {
                      <img
                        data-cy="modal-consult-silhouette"
                        width="160px"
                        height="160px"
                        class="image-silhouette"
                        src="/assets/images/silhouette.png"
                        alt="image placeholder"
                      >
                    }
                  </div>
                }
              </div>
              @if (modalService.consultant.value) {
                <div class="contacts" data-cy="modal-consultant-contacts">
                  <div class="phone">
                    <div class="icon-background">
                      <div class="icon-container">
                        <svg-icon src="assets/icons/phone.svg" [svgStyle]="{ 'width.px': 19 }"></svg-icon>
                      </div>
                    </div>
                    @if (!modalService.consultant.value.value.phone) {
                      <div class="contact-info" data-cy="consult-missing-phone">
                        {{ 'profile.missingPhone' | translate }}
                      </div>
                    } @else {
                      <a class="contact-info" href="tel:{{ modalService.consultant.value.value.phone }}" data-cy="consult-phone">
                        {{ modalService.consultant.value.value.phone }}
                      </a>
                    }
                  </div>
                  <div class="email">
                    <div class="icon-background">
                      <div class="icon-container">
                        <svg-icon src="assets/icons/envelope.svg" [svgStyle]="{ 'width.px': 19 }"></svg-icon>
                      </div>
                    </div>
                    @if (!modalService.consultant.value.value.email) {
                      <div class="contact-info" data-cy="consult-missing-mail">
                        {{ 'profile.missingEmail' | translate }}
                      </div>
                    } @else {
                      <a class="contact-info" href="mailto:{{ modalService.consultant.value.value.email }}" data-cy="consult-mail">
                        {{ modalService.consultant.value.value.email }}
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="button-container">
              <libero-button
                label="{{ 'global.iWantConsultation' | translate }}"
                btnClasses="btn--primary btn--heading"
                (click)="modalService.requestConsultation()"
              ></libero-button>
            </div>
            <div class="footer-description footer-description--constultation">
              {{ 'modal.consultationFooterDescription' | translate }}
            </div>
          </div>
        }
      }
      <!-- rebalancing confirm -->
      @if (modalService.rebalancingControl) {
        <div>
          <div class="rebalancing-content">
            {{ 'modal.rebalancingDescription' | translate }}
            <div class="mt-4">
              {{ 'modal.rebalancingQuestion' | translate }}
              <div class="rebalancing-tooltip-container">
                <libero-tooltip-button>
                  {{ 'global.tooltips.rebalancing' | translate }}
                </libero-tooltip-button>
              </div>
            </div>
          </div>
          <div class="rebalancing-buttons-container">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.activate' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmRebalancing()"
              data-cy="confirm-rebalancing-btn"
            ></libero-button>
          </div>
        </div>
      }
      <!-- DIP confirm -->
      @if (modalService.dipControl || modalService.efektikaDraftAcceptDipConfirm) {
        <div>
          <div class="rebalancing-content">
            @if (modalService.dipOpenSource === 'new-portfolio') {
              {{ 'modal.dipExplainNewPortfolio' | translate }}
            }
            @if (modalService.dipOpenSource === 'new-strategy') {
              {{ 'modal.dipExplainNewStrategy' | translate }}
            }
          </div>
          <div class="rebalancing-buttons-container">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.yes' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.efektikaDraftAcceptDipConfirm ? modalService.confirmDipEfektika() : modalService.confirmDip()"
              [preloader]="!!(modalService.efektikaDraftAcceptDipConfirm && modalService.efektikaDraftAcceptDipConfirm.loading)"
            ></libero-button>
          </div>
        </div>
      }
      <!-- withdraw with consult offer -->
      @if (modalService.withdrawConfirmTemp) {
        <div data-cy="withdraw-confirm-consult-temp-modal">
          <p class="consult-offer">
            {{ (modalService.withdrawConfirmTemp.efektika ? 'modal.withdrawEfektika' : 'modal.withdrawConsultOffer') | translate }}
          </p>
          @if (modalService.withdrawConfirmTemp.efektika) {
            <p class="consult-offer consult-offer--confirm">
              {{ 'modal.withdrawEfektikaConfirm' | translate }}
            </p>
          }
          <div class="offer-buttons-container">
            <libero-button
              label="{{ 'global.buttons.confirmConsultWithdraw' | translate }}"
              btnClasses="btn--primary btn--heading"
              data-cy="withdraw-confirm-button"
              (click)="modalService.openWithdrawFromConfirmModal()"
            ></libero-button>
            <libero-button
              label="{{ 'global.iWantConsultation' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.openConsultModal()"
              data-cy="withdraw-consult-button"
            ></libero-button>
          </div>
        </div>
      }
      <!-- withdraw confirm -->
      @if (modalService.withdraw && !modalService.preloader) {
        <div data-cy="withdraw-confirm-temp-modal">
          <div class="withdraw-content" data-cy="withdraw-confirm-modal-content">
            @if (modalService.withdraw.investmentType === 'portfolio') {
              {{ 'money.confirmWindow.text1Portfolio' | translate }}
            } @else {
              {{ 'money.confirmWindow.text1Strategy' | translate }}
            }
            &#34;<div class="withdraw-name">{{ modalService.withdraw.name }}</div>&#34;
            @if (modalService.withdraw.modalType === 'UNDER-LIMIT') {
              {{ 'money.confirmWindow.text2' | translate }}
              <div class="withdraw-amount">
                {{ modalService.withdraw.amount | price:modalService.withdraw.currency }}
              </div>
              {{ 'money.confirmWindow.toAccount' | translate }} {{ modalService.withdraw.bankAccount }}.
            }
            @if (modalService.withdraw.modalType === 'OVER-LIMIT') {
              {{ 'money.confirmWindow.text3' | translate }}
              <div class="withdraw-amount">
                {{ modalService.withdraw.valueWithoutPendingDeposits | price:modalService.withdraw.currency }}
              </div>
              {{ 'money.confirmWindow.toAccount' | translate }} {{ modalService.withdraw.bankAccount }} {{ 'money.confirmWindow.text4' | translate }}
            }
            @if (modalService.withdraw.modalType === 'ALL') {
              {{ 'money.confirmWindow.text5' | translate }}
              <div class="withdraw-amount">
                {{ modalService.withdraw.amount | price:modalService.withdraw.currency }}
              </div>
              {{ 'money.confirmWindow.toAccount' | translate }} {{ modalService.withdraw.bankAccount }} {{ 'money.confirmWindow.text4' | translate }}
            }
            @if (modalService.withdraw.dip) {
              <div class="dip-additional-info">
                @if (modalService.withdraw.modalType === 'ALL' || modalService.withdraw.modalType === 'OVER-LIMIT') {
                  @if (modalService.withdraw.investmentType === 'portfolio') {
                    {{ 'money.dipConfirm.portfolioLiquidationText1' | translate }}
                  } @else {
                    {{ 'money.dipConfirm.strategyLiquidationText1' | translate }}
                  }
                } @else {
                  @if (modalService.withdraw.investmentType === 'portfolio') {
                    {{ 'money.dipConfirm.portfolioText1' | translate }}
                  } @else {
                    {{ 'money.dipConfirm.strategyText1' | translate }}
                  }
                }
                <div class="dip-quotation">
                  {{ 'money.dipConfirm.quotation' | translate }}
                </div>
                @if (modalService.withdraw.investmentType === 'portfolio') {
                  {{ 'money.dipConfirm.portfolioText2' | translate }}
                } @else {
                  {{ 'money.dipConfirm.strategyText2' | translate }}
                }
              </div>
            }
          </div>
          <div class="withdraw-buttons-container">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            @if (modalService.withdraw.modalType === 'UNDER-LIMIT') {
              <libero-button
                label="{{ 'money.confirmWindow.buttonConfirm' | translate }}"
                btnClasses="btn--primary btn--heading"
                (click)="modalService.confirmWithdraw()"
                data-cy="withdraw-post-confirm"
              ></libero-button>
            } @else {
              <libero-button
                label="{{ 'money.withdrawAllButtonLabel' | translate }}"
                btnClasses="btn--primary btn--heading"
                (click)="modalService.confirmWithdraw()"
              ></libero-button>
            }
          </div>
        </div>
      }
      <!-- video preview -->
      @if (modalService.videoPreview) {
        <div class="video-preview-container" data-cy="modal-video-container">
          <video controls class="video-preview" autoplay>
            <source src="{{ modalService.videoPreview.url }}" type="video/mp4"  data-cy="modal-video-playable">
            Your browser does not support the video tag.
          </video>
        </div>
      }
      <!-- etf/language confirm -->
      @if (modalService.etfLanguageConfirm) {
        <div class="etf-confirm" data-cy="etf-confirm-modal">
          {{ 'modal.etfConfirm' | translate }}
          <div class="etf-confirm-buttons">
            <libero-button
              label="{{ 'global.buttons.no' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.yes' | translate }}"
              btnClasses="btn--primary btn--heading"
              data-cy="etf-confirm-modal-confirm-btn"
              (click)="modalService.confirmEtfUpdate()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- investment questionaire disabled -->
      @if (modalService.investmentQuestionaireExpired) {
        <div data-cy="questionaire-expired-modal">
          <div class="investment-questionaire-expired">
            <h3>{{ 'modal.investmentQuestionaireExpired' | translate }}</h3>
            <p>{{ 'modal.investmentQuestionaireExpiredInfo' | translate }}</p>
            <libero-button
              label="{{ 'global.buttons.fillinQuestionaire' | translate }}"
              btnClasses="btn--primary"
              (click)="goToInvestmentQuestionaireForm()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- confirmation of rebalancing disable -->
      @if (modalService.rebalancingSwitchoffConfirm) {
        <div>
          <div class="investment-rebalancing-confirm" data-cy="investment-rebalancing-confirm">
            <p>{{ 'modal.investmentRebalancingConfirm' | translate }}</p>
            <div class="confirm-disable-realancing">
              <libero-button
                label="{{ 'modal.backFromRebalancingConfirm' | translate }}"
                btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
                (click)="closeModal()"
              ></libero-button>
              <libero-button
                label="{{ 'modal.confirmRebalancing' | translate }}"
                btnClasses="btn--primary btn--responsive-height"
                (click)="modalService.confirmRebalancingSwitchoff()"
                data-cy="investment-rebalancing-confirm-btn"
              ></libero-button>
            </div>
          </div>
        </div>
      }
      <!-- confirmation of fees change -->
      @if (modalService.feeChangeConfirm) {
        <div>
          <div class="investment-fees-change" data-cy="investment-fees-change-modal">
            <p [innerHTML]="'modal.changeStrategyFees.reason' | translate"></p>
            <p class="pb-5">{{ 'modal.changeStrategyFees.highlightedReason' | translate }}</p>
            <div class="confirm-fees-change">
              <libero-button
                label="{{ 'global.buttons.back' | translate }}"
                btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
                (click)="closeModal()"
              ></libero-button>
              <libero-button
                label="{{ 'modal.changeStrategyFees.confirm' | translate }}"
                btnClasses="btn--primary btn--responsive-height"
                (click)="modalService.confirmFeesChange()"
                data-cy="confirm-fees-change-btn"
              ></libero-button>
            </div>
          </div>
        </div>
      }
      <!-- executionSwitchAddition -->
      @if (modalService.executionSwitchAddition && !modalService.preloader) {
        <div class="unsigned-container unsigned-container--additions">
          <div class="additions-header">
            <p>{{ 'profile.clientAdditions.modalExecutionOnlySwitch.header' | translate }}</p>
          </div>
          <p>{{ 'profile.clientAdditions.modalExecutionOnlySwitch.textP1' | translate }}</p>
          <p>{{ 'profile.clientAdditions.modalExecutionOnlySwitch.textP2' | translate }}</p>
          <p><b>{{ 'profile.clientAdditions.modalExecutionOnlySwitch.textP3' | translate }}</b></p>
          <div class="client-addition-buttons">
            <libero-button
              label="{{ 'global.buttons.close' | translate }}"
              btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'profile.clientAdditions.modalExecutionOnlySwitch.confirm' | translate }}"
              btnClasses="btn--primary btn--responsive-height"
              data-cy="investment-rebalancing-confirm-btn"
              (click)="modalService.requestSignExecutionSwitch()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- portfoliosMigrateAddition -->
      @if (modalService.portfoliosMigrateAddition && !modalService.preloader) {
        <div class="unsigned-container unsigned-container--additions">
          <div class="additions-header">
            <p>{{ 'profile.clientAdditions.modalPortfoliosMigrate.header' | translate }}</p>
          </div>
          <p>{{ 'profile.clientAdditions.modalPortfoliosMigrate.textP1' | translate }}</p>
          <p>{{ 'profile.clientAdditions.modalPortfoliosMigrate.textP2' | translate }}</p>
          <p>{{ 'profile.clientAdditions.modalPortfoliosMigrate.textP3' | translate }}</p>
          <p>{{ 'profile.clientAdditions.modalPortfoliosMigrate.textP4' | translate }}</p>
          <div class="client-addition-buttons">
            <libero-button
              label="{{ 'global.buttons.close' | translate }}"
              btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'profile.clientAdditions.modalPortfoliosMigrate.confirm' | translate }}"
              btnClasses="btn--primary btn--responsive-height"
              data-cy="investment-rebalancing-confirm-btn"
              (click)="modalService.requestSignPortfoliosMigrate()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- client addition sign confirm to client -->
      @if (modalService.clientAddition) {
        <div class="unsigned-container">
          <p class="investment-rebalancing-confirm">{{ ('profile.clientAdditions.signSendModal.' + modalService.clientAddition) | translate }}</p>
          <div class="text-center">
            <libero-button
              data-cy="close-client-addition"
              label="{{ 'global.buttons.close' | translate }}"
              btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
              (click)="closeModal('/user')"
            ></libero-button>
          </div>
        </div>
      }
      <!-- unsigned addition -->
      @if (modalService.unsignedAdditionId && !modalService.preloader) {
        <div data-cy="unsigned-container" class="unsigned-container">
          <p>
            {{ 'modal.additionalSignAddressing' | translate }}
          </p>
          <p>
            {{ 'modal.additionalSignP1' | translate }}
          </p>
          <p>
            {{ 'modal.additionalSignP2' | translate }}
          </p>
          <div class="sign-email-preview">
            <p>
              <b>
                {{ 'modal.additionalSignMail.row3' | translate }}
              </b>
            </p>
            <p>
              <b>
                {{ 'modal.additionalSignMail.row4' | translate }}
              </b>
            </p>
            <p>
              {{ 'modal.additionalSignMail.row5' | translate }} <b>{{ 'modal.additionalSignMail.row5Bold' | translate }}</b>
            </p>
            <p>
              {{ 'modal.additionalSignMail.row6' | translate }}
            </p>
            <p>
              {{ 'modal.additionalSignMail.row7' | translate }}
            </p>
            <p>
              {{ 'modal.additionalSignMail.row8' | translate }} <a href="{{ 'modal.additionalSignMail.row8Link' | translate }}">{{ 'modal.additionalSignMail.row8Link' | translate }}</a>
            </p>
            <p>
              {{ 'modal.additionalSignMail.row9' | translate }}
            </p>
            @if (loggedUser) {
              <table class="mb-2">
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh1' | translate }}</th>
                  <td colspan="2">{{ loggedUser.name }} {{ loggedUser.surname }}</td>
                </tr>
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh2' | translate }}</th>
                  <td colspan="2">{{ loggedUser.personalId }}</td>
                </tr>
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh3' | translate }}</th>
                  <td colspan="2"><!-- empty --></td>
                </tr>
                @if (userDomicileAddress) {
                  <tr>
                    <th>{{ 'modal.additionalSignMail.tableTh4' | translate }}</th>
                    <td colspan="2">{{ userDomicileAddress.streetName }} {{ userDomicileAddress.descriptionNo }}, {{ userDomicileAddress.zip }} {{ userDomicileAddress.city }}, {{ userDomicileAddress.countryCode | localeCountryName }}</td>
                  </tr>
                }
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh5' | translate }}</th>
                  <td colspan="2"><!-- empty --></td>
                </tr>
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh6' | translate }}</th>
                  <td colspan="2">
                    {{ modalService.preferedContractBankAccount }}
                  </td>
                </tr>
                <tr>
                  <th>{{ 'modal.additionalSignMail.tableTh7' | translate }}</th>
                  <td>{{ 'modal.additionalSignMail.tableTh8' | translate }}</td>
                  <td>{{ loggedUser.phoneNumber }}</td>
                </tr>
                <tr>
                  <td><!-- empty --></td>
                  <td>{{ 'modal.additionalSignMail.tableTh9' | translate }}</td>
                  <td>{{ loggedUser.email }}</td>
                </tr>
                <tr >
                  <td><!-- empty --></td>
                  <td>{{ 'modal.additionalSignMail.tableTh10' | translate }}</td>
                  @if (userPostalAddress) {
                    <td>{{ userPostalAddress.streetName }} {{ userPostalAddress.descriptionNo }}, {{ userPostalAddress.zip }} {{ userPostalAddress.city }}, {{ userPostalAddress.countryCode | localeCountryName }}</td>
                  }
                </tr>
              </table>
            }
            <p [innerHTML]="'modal.additionalSignMail.footer1' | translate"></p>
            <p [innerHTML]="'modal.additionalSignMail.footer2' | translate"></p>
            <p [innerHTML]="'modal.additionalSignMail.footer3' | translate"></p>
          </div>
          <div
            data-cy="req-sign-mail-button"
            class="unsigned-button"
            (click)="modalService.postAdditionSignMail()"
            (keydown.space)="modalService.postAdditionSignMail()"
            (keydown.enter)="modalService.postAdditionSignMail()"
            tabindex="0"
          >
            {{ 'modal.additionalSignButton' | translate }}
          </div>
        </div>
      }
      @if (modalService.additionalSignErrored) {
        <div class="unsigned-container text-center" data-cy="unsigned-post-error">
          {{ 'toastNotifications.messages.additionalSignError' | translate }}
        </div>
      }
      @if (modalService.sucessfullySigned) {
        <div data-cy="awaiting-sign-container" class="unsigned-container" data-cy="sucessfully-signed-info">
          {{ 'toastNotifications.messages.additionalSignEmailConfirmation' | translate }}
        </div>
      }
      <!-- investment delete confirm -->
      @if (modalService.portfolioToDelete && !modalService.preloader) {
        <div class="delete-confirm" data-cy="delete-confirm-modal">
          <p>
            {{ 'modal.deleteConfirm.text1' | translate }}
            <b>
              {{ 'modal.deleteConfirm.text2' | translate }}
            </b>
            {{ (modalService.portfolioToDelete.portfolioType === 'STRATEGY' ? 'global.buttons.strategy' : 'global.buttons.portfolio') | translate }}
            "{{ modalService.portfolioToDelete.name }}"?
          </p>
          <div class="delete-confirm-buttons">
            <libero-button
              label="{{ 'global.buttons.yes' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmInvestmentDelete()"
              data-cy="delete-portfolio-confirm-yes"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.no' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- portfolio VAT confirm -->
      @if(!modalService.preloader && (modalService.newPortfolioVatConfirm || modalService.draftPortfolioVatConfirm)) {
        <div class="vat-confirmation">
          <p><b>{{ 'modal.vatConfirm.heading' | translate }}</b></p>
          <p [innerHTML]="'modal.vatConfirm.desc' | translate"></p>
          <div class="confirm-vat-buttons">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'modal.vatConfirm.btn' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.handlePortfolioVatAccept()"
              data-cy="modal-create-investment-button"
              [preloader]="modalService.draftPortfolioVatConfirm?.preloader"
            ></libero-button>
          </div>
        </div>
      }
      <!-- fee configs -->
      @if (!modalService.preloader && modalService.feeConfigs) {
        <div class="fee-config-modal-container" data-cy="fee-config-modal">
          <div class="fee-heading">
            {{ 'modal.feeConfigs.header' | translate }}
          </div>
          @if (modalService.feeConfigs.regularEntryFeeConfig) {
            <div class="fee-wrapper">
              <libero-fees-entry-regular-config-dropdown
                [feeAmounts]="modalService.feeConfigs.entryFeeInfo"
                [feeConfig]="modalService.feeConfigs.regularEntryFeeConfig"
                [hasVat]="modalService.feeConfigs.hasVat"
                [opfFeeImplVariant]="opfFeeImplVariant"
              ></libero-fees-entry-regular-config-dropdown>
            </div>
          }
          <div class="fee-wrapper fee-wrapper--config">
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.oneTimeEntryFeeConfig.entryFee"
              [type]="'entry'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.mngFeeConfig.mngFee"
              [type]="'management'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.performanceFeeConfig.performanceFee"
              [type]="'performance'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            @if (modalService.feeConfigs.opfFeeImplementation) {
              <libero-fees-config-dropdown
                [amount]="modalService.feeConfigs.variableServiceFeeConfig.variableServiceFee"
                [type]="'variableService'"
                [opfFeeImplVariant]="opfFeeImplVariant"
                data-cy="variable-service-fee-config-dropdown"
              ></libero-fees-config-dropdown>
            }
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.exitFeeConfig.exitFee"
              [type]="'exit'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
          </div>
          @if(modalService.feeConfigs.opfFeeImplementation) {
            <p class="fees-footer-info" data-cy="fee-config-modal-footer-text">
              {{ 'modal.feeConfigs.footerInfo' | translate }}
            </p>
          }
        </div>
      }
      <!-- investment create confirm (new strategy) -->
      @if (modalService.investmentConfirm) {
        <div class="create-confirm-container" data-cy="create-invesment-confirm-modal">
          <p>
            {{ (modalService.isNewInvestPortfolio ? 'modal.createConfirm.confirmTextPortfolioPt1' : 'modal.createConfirm.confirmTextStrategyPt1') | translate }}
            "{{ modalService.investmentConfirm.name }}"
            {{ 'modal.createConfirm.confirmTextPt2' | translate }}
            {{ modalService.investmentConfirm.regularDeposit | price:loggedUser?.currencyCode ?? 'CZK' }}.
            {{ 'modal.createConfirm.confirmTextPt3' | translate }}
          </p>
          <div class="confirm-create-buttons">
            <libero-button
              label="{{ 'global.buttons.goBack' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.confirm' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmNewInvestmentHighRegular()"
              data-cy="modal-create-investment-button"
            ></libero-button>
          </div>
        </div>
      }
      <!-- investment create confirm (efektika draft) -->
      @if (modalService.efektikaDraftAcceptRegularExceedConfirm && modalService.efektikaModalChainingDraftData) {
        <div class="create-confirm-container" data-cy="create-efektika-invesment-confirm-modal">
          <p>
            {{ 'modal.createConfirm.confirmTextStrategyPt1' | translate }}
            "{{ modalService.efektikaModalChainingDraftData.name }}"
            {{ 'modal.createConfirm.confirmTextPt2' | translate }}
            {{ modalService.efektikaModalChainingDraftData.regularDeposit | price:loggedUser?.currencyCode ?? 'CZK' }}.
            {{ 'modal.createConfirm.confirmTextPt3' | translate }}
          </p>
          <div class="confirm-create-buttons">
            <libero-button
              label="{{ 'global.buttons.goBack' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.confirm' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmRegularExceededEfektika()"
              data-cy="modal-create-investment-button"
              [preloader]="!!(modalService.efektikaDraftAcceptRegularExceedConfirm && modalService.efektikaDraftAcceptRegularExceedConfirm.loading)"
            ></libero-button>
          </div>
        </div>
      }

      <!-- cancel regular withdrawal -->
      @if (modalService.cancelRegularWithdrawal) {
        <div class="cancel-regular-container">
          @if(modalService.cancelRegularWithdrawal.preloader) {
            <libero-preload-spinner></libero-preload-spinner>
          } @else {
            <p>
              {{ (modalService.cancelRegularWithdrawal.investmentType === 'strategy' ? 'modal.cancelRegularWithdrawalPartStrategy' : 'modal.cancelRegularWithdrawalPartPortfolio') | translate }}
              <b>&#34;{{ modalService.cancelRegularWithdrawal.withdrawStrategyName }}&#34;</b>?
            </p>

            <div class="regular-withdrawal-buttons">
              <div class="btn-wrapper">
                <libero-button
                  label="{{ 'global.buttons.back' | translate }}"
                  btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
                  (click)="closeModal()"
                  data-cy="rent-confirm-withrawal-cancel-back-btn"
                ></libero-button>
              </div>
              <libero-button
                label="{{ 'global.continue' | translate }}"
                btnClasses="btn--primary btn--heading"
                data-cy="rent-confirm-withrawal-cancel-btn"
                (click)="modalService.confirmRegularWithdrawCancelModal()"
              ></libero-button>
            </div>
          }
        </div>
      }

      <libero-withdrawal-draft-comment-modal
        [draftWithdrawalComment]="modalService.draftWithdrawalComment"
      ></libero-withdrawal-draft-comment-modal>

      <libero-transactions-export-modal
        [show]="modalService.transactionsExportForm"
        (onExportFinish)="modalService.close()"
      ></libero-transactions-export-modal>

      <libero-new-regular-withdrawal-modal
        [show]="modalService.newRegularWithdrawal && !!loggedUser"
        (continueBtnClick)="modalService.confirmNewRegularWithdraw()"
        (backBtnClick)="modalService.close()"
      ></libero-new-regular-withdrawal-modal>

      <libero-init-sign-in-modal
        [show]="modalService.initSignIn && !!loggedUser"
        [hasPortfolioOrStrategy]="hasAnyPortfolioOrStrategy"
        [maxRiskScore]="loggedUser?.maxRiskScore"
        [hasStrategiesAccess]="loggedUser?.managementType === 'EXECUTION_ONLY'"
        (modalAddMoneyLinkClick)="modalService.handleInitLogInAddMoney()"
        (modalAddPortfolioBtnClick)="modalService.handleInitLogInAddPortfolio()"
        (modalAddStrategyBtnClick)="modalService.handleInitLogInAddStrategy()"
        (modalConsultBtnClick)="modalService.handleInitLogInConsultation()"
      ></libero-init-sign-in-modal>
      <libero-draft-accept-refuse-confirm-modal
        [show]="modalService.draftAcceptRefuseConfirm && modalService.draftAcceptRefuseConfirm.portfolio && !!loggedUser"
        [type]="modalService.draftAcceptRefuseConfirm && modalService.draftAcceptRefuseConfirm.type"
        [portfolio]="modalService.draftAcceptRefuseConfirm && modalService.draftAcceptRefuseConfirm.portfolio"
        (yesBtnClick)="modalService.onAcceptOrRefuseDraft(modalService.draftAcceptRefuseConfirm)"
        (noBtnClick)="modalService.close()"
        [loadingConfirm]="modalService.draftAcceptRefuseConfirm && modalService.draftAcceptRefuseConfirm.loading"
      ></libero-draft-accept-refuse-confirm-modal>

      <libero-client-accept-efektika-draft-strategy-modal
        [show]="modalService.efektikaDraftAcceptConfirm && !!loggedUser"
        (continueBtnClick)="modalService.onAcceptEfektikaDraft(modalService.efektikaDraftAcceptConfirm)"
        (backBtnClick)="modalService.close()"
        [loadingConfirm]="modalService.efektikaDraftAcceptConfirm && modalService.efektikaDraftAcceptConfirm.loading"
      ></libero-client-accept-efektika-draft-strategy-modal>

      <libero-profile-fees-confirm-modal
        [show]="modalService.profileFeesConfirm && !!loggedUser"
        (continueBtnClick)="modalService.confirmProfileFeesTransferConfirmModal()"
        (backBtnClick)="modalService.close()"
      ></libero-profile-fees-confirm-modal>

      <!-- default content -->
      <ng-content>
      </ng-content>
      @if (!modalService.preloader && modalService.apiError) {
        <div class="api-error-container" data-cy="api-error-container">
          {{ 'global.error.loadData' | translate }}
        </div>
      }
    </div>
  </div>
}
